import React from 'react';
import { Box, Typography, List, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import ProjectListItem from './ProjectListItem';
import { sectionStyles, projectStyles } from '../../styles/drawerStyles';

/**
 * 프로젝트 섹션 컴포넌트
 * @param {object} props - 컴포넌트 props
 * @returns {JSX.Element} - 프로젝트 섹션
 */
const ProjectSection = ({
  projects,
  history,
  openProjects,
  toggleProject,
  setProjectModalOpen,
  setProjectMenuAnchor,
  setProjectMenuIdx,
  // HistoryListItem props
  selectedHistoryId,
  setDrawerOpen,
  setHistoryMenuAnchor,
  setHistoryMenuIdx,
  projectSubMenuRefs,
  historyMenuRefs,
  handleAddHistoryToProject,
  handleEditHistory,
  handleDeleteClick,
  menuOpenIdx,
  setMenuOpenIdx,
  setHistory,
  setAnalyzedVideoId,
  setAnalyzedTitle,
  setAnalyzedUrl
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={sectionStyles.projectSection}>
      <Typography variant="subtitle2" sx={sectionStyles.sectionTitle}>
        {t('drawer.projects')}
      </Typography>
      <List sx={{ p: 0 }}>
        {projects.map((project, idx) => {
          const projectHistories = history.filter(h => h.projectId === project.id && h.status === 'active');
          return (
            <ProjectListItem
              key={project.id}
              project={project}
              idx={idx}
              projectHistories={projectHistories}
              isOpen={openProjects[project.id]}
              onToggle={() => toggleProject(project.id)}
              onMenuClick={(e, idx) => {
                setProjectMenuAnchor(e.currentTarget);
                setProjectMenuIdx(idx);
              }}
              selectedHistoryId={selectedHistoryId}
              setDrawerOpen={setDrawerOpen}
              setHistoryMenuAnchor={setHistoryMenuAnchor}
              setHistoryMenuIdx={setHistoryMenuIdx}
              projectSubMenuRefs={projectSubMenuRefs}
              historyMenuRefs={historyMenuRefs}
              projects={projects}
              handleAddHistoryToProject={handleAddHistoryToProject}
              handleEditHistory={handleEditHistory}
              handleDeleteClick={handleDeleteClick}
              menuOpenIdx={menuOpenIdx}
              setMenuOpenIdx={setMenuOpenIdx}
              setHistory={setHistory}
              setAnalyzedVideoId={setAnalyzedVideoId}
              setAnalyzedTitle={setAnalyzedTitle}
              setAnalyzedUrl={setAnalyzedUrl}
            />
          );
        })}
      </List>
      <Button
        startIcon={<AddIcon />}
        onClick={() => setProjectModalOpen(true)}
        sx={projectStyles.addButton}
      >
        {t('drawer.newProject')}
      </Button>
    </Box>
  );
};

export default ProjectSection; 